module.exports = __webpack_public_path__ + "./assets/web_mobile_display.png";